export default "__VITE_ASSET__buafvLMO__"